import { DataTable } from "mantine-datatable";
import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomPagination from "../../components/Layouts/CustomPagination";

import Dropdown from "../../components/Dropdown";
import IconCaretDown from "../../components/Icon/IconCaretDown";
import eventService from "../../service/event.service";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import StatusDropdown from "../../components/StatusDropdown";
import moment from "moment";

const Basic = () => {
  const navigate = useNavigate();
  const [rowData, setRowData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState({ value: "allevent", label: "All" });
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedTire, setSelectedTire] = useState(null);
  const [categoryData, setCategoryData] = useState([]);
  const [tireData, setTireData] = useState([]);
  const [page, setPage] = useState(0);
  const PAGE_SIZES = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
  const [recordsData, setRecordsData] = useState("");
  const [loading, setLoading] = useState(false);
  const [checkAll, setCheckAll] = useState(null);
  const initialCheckedState = rowData.map(() => ({
    check: false,
    event_ids: [],
  }));
  const [checked, setChecked] = useState(initialCheckedState);
  const [editingTime, setEditingTime] = useState(null);
  const [timeInputs, setTimeInputs] = useState({});

  const isRtl =
    useSelector((state) => state.themeConfig.rtlClass) === "rtl" ? true : false;

  const statusOptions = [
    { value: "allevent", label: "All" },
    { value: "upcomingevent", label: "Upcoming" },
    // { value: "pastevent", label: "Past" },
  ];

  const optionsCategory = async () => {
    try {
      const response = await eventService.categoryOptions();
      setCategoryData(response?.data?.data);
    } catch (e) {
    }
  };
  const optionsTire = async () => {
    try {
      const response = await eventService.tireOptions();
      setTireData(response?.data?.data);
    } catch (e) {
    }
  };
  const categoryOptions = categoryData.map((item) => ({
    value: item.cat_id,
    label: item.cat_name,
  }));
  const tireOption = tireData.map((item) => ({
    value: item.tier_id,
    label: item.name,
  }));
  useEffect(() => {
    setSelectedCategory(categoryOptions[0]);
    setSelectedTire(tireOption[0]);
  }, [categoryData, tireData]);

  const getAllEvent = async () => {
    try {
      setLoading(true);
      const data = {
        page: page,
        size: pageSize,
        eventStartDate: "",
        eventEndDate: "",
        categoryId: selectedCategory !== null && [selectedCategory.value],
      };
      const response = await eventService.allEvent(
        data,
        selectedStatus

        // page,
        // pageSize,
        // selectedCategory !== null && selectedCategory.value,
        // selectedStatus || "upcomingevent"
      );
      setLoading(false);
      console.log("All Events Response:", response?.data?.data);
      const result = response?.data?.data;
      setRowData(result);
      setRecordsData(response?.data?.total);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllEvent();
  }, [page, pageSize, selectedTire, selectedCategory, selectedStatus]);

  useEffect(() => {
    optionsCategory();
    optionsTire();
  }, []);

  const handleStatusChange = (option) => {
    setSelectedStatus(option);
  };
  const handleCategoryChange = (option) => {
    setLoading(true);
    setSelectedCategory(option);
  };
  const handleTireChange = (option) => {
    setLoading(true);
    setSelectedTire(option);
  };
  const handleTireUpdateChange = async (option) => {
    try {
      const event_ids = checked
        .filter((item) => item.check === true)
        .flatMap((item) => item.event_ids);
      const response = await eventService.updateData({
        event_id: event_ids,
        tier_id: option?.value,
      });
      if (event_ids.length !== 0) {
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"success"}`,
          },
        });
        toast.fire({
          title: "Data Added successfully",
        });
      }
      setCheckAll(null);
      setChecked(initialCheckedState);
    } catch (e) {
      const toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        showCloseButton: true,
        customClass: {
          popup: `color-${"danger"}`,
        },
      });
      toast.fire({
        title: "Something went wrong",
      });
    }

    // setLoading(true);
    // setSelectedTireUpdate(option);
  };

  const handleAthleteUpdate = async () => {
    try {
      const event_ids = checked
        .filter((item) => item.check === true)
        .flatMap((item) => item.event_ids);

      if (event_ids.length === 0) {
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"warning"}`,
          },
        });
        toast.fire({
          title: "Please select at least one event",
        });
        return;
      }

      // Call the API to update program athletes
      const response = await eventService.updateProgramAthletes({
        event_id: event_ids,
      });

      if (response) {
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"success"}`,
          },
        });
        toast.fire({
          title: "Athletes updated successfully",
        });
      }

      setCheckAll(null);
      setChecked(initialCheckedState);
      getAllEvent(); // Refresh the data

    } catch (e) {
      const toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        showCloseButton: true,
        customClass: {
          popup: `color-${"danger"}`,
        },
      });
      toast.fire({
        title: "Something went wrong",
      });
    }
  };

  const handleResultUpdate = async () => {
    try {
      const event_ids = checked
        .filter((item) => item.check === true)
        .flatMap((item) => item.event_ids);

      if (event_ids.length === 0) {
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"warning"}`,
          },
        });
        toast.fire({
          title: "Please select at least one event",
        });
        return;
      }

      // Call the API to update program results
      const response = await eventService.updateProgramResult({
        event_id: event_ids,
      });

      if (response) {
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"success"}`,
          },
        });
        toast.fire({
          title: "Results updated successfully",
        });
      }

      setCheckAll(null);
      setChecked(initialCheckedState);
      getAllEvent(); // Refresh the data

    } catch (e) {
      const toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        showCloseButton: true,
        customClass: {
          popup: `color-${"danger"}`,
        },
      });
      toast.fire({
        title: "Something went wrong",
      });
    }
  };

  const handleTimeUpdate = async (eventId, eventDate) => {
    try {
      // Check if event date is in the future
      const eventDateMoment = moment(eventDate);
      const now = moment();
      
      if (eventDateMoment.isBefore(now, 'day')) {
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"warning"}`,
          },
        });
        toast.fire({
          title: "Cannot edit time for past events",
        });
        return;
      }

      const timeValue = timeInputs[eventId];
      if (!timeValue) {
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"warning"}`,
          },
        });
        toast.fire({
          title: "Please select a time",
        });
        return;
      }

      // Parse UTC time and create timestamp with event's date
      const [hours, minutes, seconds] = timeValue.split(':').map(Number);
      
      // Use event's actual date, not today's date
      const eventDateWithTime = moment(eventDate).hours(hours).minutes(minutes).seconds(seconds || 0);
      const futureTime = eventDateWithTime.utc();
      
      // Only validate time if event date is today
      if (eventDateMoment.isSame(moment(), 'day')) {
        if (futureTime.isBefore(moment().utc())) {
          const toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            showCloseButton: true,
            customClass: {
              popup: `color-${"warning"}`,
            },
          });
          toast.fire({
            title: "Time must be in the future for today's events",
          });
          return;
        }
      }

      const timestamp = futureTime.valueOf();

      const response = await eventService.updateTimestamp({
        event_id: eventId,
        event_start_timestamp: timestamp
      });

      if (response) {
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"success"}`,
          },
        });
        toast.fire({
          title: "Time updated successfully",
        });
      }

      setEditingTime(null);
      setTimeInputs(prev => ({ ...prev, [eventId]: '' }));
      getAllEvent(); // Refresh the data

    } catch (e) {
      const toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        showCloseButton: true,
        customClass: {
          popup: `color-${"danger"}`,
        },
      });
      toast.fire({
        title: "Something went wrong",
      });
    }
  };
  // useEffect(() => {
  //   dispatch(setPageTitle("Advanced Table"));
  // });

  // const [sortStatus, setSortStatus] = useState();
  const [sortStatus, setSortStatus] = useState({
    columnAccessor: "id",
    direction: "asc",
  });

  const handleChange = (type, page) => {
    const total = recordsData / pageSize;
    const newPage = Math.ceil(total);
    if (type === "Next") {
      if (page < newPage - 1) {
        setPage(page + 1);
      }
    } else if (type === "Previous") {
      if (page > 0) {
        setPage(page - 1);
      }
    } else if (type === "First") {
      setPage(0);
    } else if (type === "Last") {
      setPage(newPage - 1);
    } else {
      setPage(page);
    }
  };

  const handleDataPerPage = (e) => {
    setPageSize(e.target.value);
  };

  useEffect(() => {
    setPage(0);
  }, [pageSize]);

  const handleRefreshData = async () => {
    try {
      const event_ids = checked
        .filter((item) => item.check === true)
        .flatMap((item) => item.event_ids);
      await eventService.RefreshData({ event_id: event_ids });
      if (event_ids.length !== 0) {
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"success"}`,
          },
        });
        toast.fire({
          title: "Data Added successfully",
        });
      }

      setCheckAll(null);
      setChecked(initialCheckedState);
    } catch (error) {
      const toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        showCloseButton: true,
        customClass: {
          popup: `color-${"danger"}`,
        },
      });
      toast.fire({
        title: "Something went wrong",
      });
    }
  };
  const handleReset = useCallback(() => {
    setSelectedCategory(categoryOptions[0]);
    setSelectedStatus("allevent");
    setSelectedTire(tireOption[0]);
    // setSelectedCatOptionValue("");
    // setSelectedCatOption("");
    getAllEvent();
  }, [selectedCategory, selectedTire]);
  useEffect(() => {
    setChecked(
      rowData.map((item) => ({ check: false, event_ids: item.event_ids || [] }))
    );
  }, [rowData]);

  const handleSingleData = (check, index, event_ids) => {
    setChecked((prev) => {
      const updatedChecked = [...prev];
      updatedChecked[index] = { check, event_ids: event_ids || [] };
      return updatedChecked;
    });
  };

  const handleSelectAll = (e) => {
    const check = e.target.checked;
    setCheckAll(check);
    setChecked(rowData.map((item) => ({ check, event_ids: item.event_ids || [] })));
  };

  return (
    // <DefaultLayout>
    <div>
      <div className="panel mt-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex gap-5 items-center justify-center">
            <h5 className="font-semibold text-lg dark:text-white-light">
              Events
            </h5>
            <div className="dropdown">
              <Dropdown
                placement={`${isRtl ? "bottom-start" : "bottom-end"}`}
                btnClassName="btn btn-outline-primary dropdown-toggle shadow-none"
                button={
                  <>
                    {selectedCategory
                      ? selectedCategory.label
                      : categoryData[0]?.cat_name}
                    <span>
                      <IconCaretDown className="ltr:ml-1 rtl:mr-1 inline-block" />
                    </span>
                  </>
                }
                options={categoryOptions}
                onOptionSelect={handleCategoryChange}
              ></Dropdown>
            </div>
            {/* <div className="dropdown">
              <StatusDropdown
                placement={`${isRtl ? "bottom-start" : "bottom-end"}`}
                btnClassName="btn btn-outline-primary dropdown-toggle shadow-none"
                button={
                  <>
                    {selectedTire ? selectedTire.label : tireData[0]?.name}
                    <span>
                      <IconCaretDown className="ltr:ml-1 rtl:mr-1 inline-block" />
                    </span>
                  </>
                }
                options={tireOption}
                onOptionSelect={handleTireChange}
              ></StatusDropdown>
            </div> */}
            <div className="dropdown">
              <StatusDropdown
                placement={`${isRtl ? "bottom-start" : "bottom-end"}`}
                btnClassName="btn btn-outline-primary dropdown-toggle shadow-none"
                button={
                  <>
                    {selectedStatus ? selectedStatus.label : "All"}
                    <span>
                      <IconCaretDown className="ltr:ml-1 rtl:mr-1 inline-block" />
                    </span>
                  </>
                }
                options={statusOptions}
                onOptionSelect={handleStatusChange}
              ></StatusDropdown>
            </div>
            {/* <button
              type="button"
              onClick={handleReset}
              className="btn btn-primary flex items-center gap-3 shadow-none"
            >
              Reset
            </button> */}
          </div>
          {/* <button
            type="button"
            disabled={checked.length === 0}
            onClick={handleRefreshData}
            className="btn btn-primary flex items-center gap-3 shadow-none"
          >
            <IconRefresh /> Refresh
          </button> */}
          <div className="flex gap-3">
            <button
              type="button"
              disabled={
                checked.filter((item) => item.check === true).length === 0
                  ? true
                  : false
              }
              onClick={handleAthleteUpdate}
              className="btn btn-primary flex items-center gap-3 shadow-none"
            >
              Athlete
            </button>
            <button
              type="button"
              disabled={
                checked.filter((item) => item.check === true).length === 0
                  ? true
                  : false
              }
              onClick={handleResultUpdate}
              className="btn btn-primary flex items-center gap-3 shadow-none"
            >
              Result
            </button>
          </div>
        </div>
        <div className="datatables Advanced-pagination">
          {/* {loading ? (
            <p>loading.........</p>
          ) : ( */}
          <>
            <DataTable
              onProgress={"loadingg................."}
              noRecordsText="No results match your search query"
              highlightOnHover
              className="whitespace-nowrap table-hover Advanced-pagination"
              records={rowData}
              columns={[
                {
                  title: (
                    <div forHtml="checkbox">
                      <label className="flex cursor-pointer items-center">
                        <input
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={checkAll}
                          className="form-checkbox bg-white dark:bg-black"
                        />
                      </label>
                    </div>
                  ),
                  render: ({ event_ids }, index) => (
                    <div id="checkbox">
                      <label className="flex cursor-pointer items-center">
                        <input
                          type="checkbox"
                          onChange={(e) =>
                            handleSingleData(e.target.checked, index, event_ids)
                          }
                          checked={checked[index]?.check || false}
                          className="form-checkbox bg-white dark:bg-black"
                        />
                      </label>
                    </div>
                  ),
                },
                {
                  // accessor: "event_title",
                  title: "Name",
                  // sortable: true,
                  render: ({ event_title }) => (
                    <div className="font-semibold">{event_title}</div>
                  ),
                },
                {
                  // accessor: "category",
                  title: "Category",
                  // sortable: true,
                  render: ({ event_categories, is_active }) => (
                    <div
                    // style={{ color: is_active === true ? "green" : "red" }}
                    >
                      {event_categories.map((item) => item.cat_name).join(", ")}
                    </div>
                  ),
                },
                {
                  // accessor: "category",
                  title: "Date",
                  // sortable: true,
                  render: ({ event_date }) => (
                    <div>{moment(event_date).format("DD-MM-YYYY")}</div>
                  ),
                },
                {
                  title: "Time",
                  render: ({ event_start_timestamp, event_ids, event_date }) => {
                    const eventId = event_ids[0];
                    const isEditing = editingTime === eventId;
                    
                    // Check if event date is in the past to disable editing
                    const eventDateMoment = moment(event_date);
                    const now = moment();
                    const isPastEvent = eventDateMoment.isBefore(now, 'day');
                    
                    // Check if existing timestamp is in the past
                    const isPastTimestamp = event_start_timestamp && 
                      moment(parseInt(event_start_timestamp)).utc().isBefore(moment().utc());
                    
                    if (isEditing) {
                      return (
                        <div className="flex items-center gap-2">
                          <input
                            type="time"
                            step="1"
                            value={timeInputs[eventId] || ''}
                            onChange={(e) => setTimeInputs(prev => ({ 
                              ...prev, 
                              [eventId]: e.target.value 
                            }))}
                            className="form-input w-32 px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 text-sm font-medium shadow-sm hover:shadow-md bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                          />
                          <button
                            type="button"
                            onClick={() => handleTimeUpdate(eventId, event_date)}
                            className="btn btn-sm bg-green-500 hover:bg-green-600 text-white px-3 py-2 rounded-md transition-colors flex items-center gap-1"
                          >
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            Save
                          </button>
                          <button
                            type="button"
                            onClick={() => {
                              setEditingTime(null);
                              setTimeInputs(prev => ({ ...prev, [eventId]: '' }));
                            }}
                            className="btn btn-sm bg-red-500 hover:bg-red-600 text-white px-3 py-2 rounded-md transition-colors flex items-center gap-1"
                          >
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            Cancel
                          </button>
                        </div>
                      );
                    }
                    
                    return (
                      <div className="flex items-center gap-2">
                        <span>
                          {event_start_timestamp 
                            ? moment(parseInt(event_start_timestamp)).format("HH:mm:ss")
                            : "N/A"
                          }
                        </span>
                        {!isPastEvent && !isPastTimestamp && (
                          <button
                            type="button"
                            onClick={() => {
                              setEditingTime(eventId);
                              // Don't pre-populate time input to avoid timestamp conversion issues
                              setTimeInputs(prev => ({ ...prev, [eventId]: '' }));
                            }}
                            className="btn btn-sm bg-blue-500 hover:bg-blue-600 text-white px-3 py-2 rounded-md transition-colors flex items-center gap-1 text-sm"
                            title="Edit time"
                          >
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                            Edit
                          </button>
                        )}
                      </div>
                    );
                  },
                },
                {
                  // accessor: "country",
                  title: "Country",
                  // sortable: true,
                  render: ({ event_country, event_flag }) => (
                    <div className="flex items-center gap-2">
                      <div>{event_country}</div>
                    </div>
                  ),
                },
                {
                  // accessor: "action",
                  title: "Action",
                  // sortable: true,
                  render: ({ event_ids, event_title }) => (
                    <button
                      type="button"
                      className="btn btn-primary flex items-center gap-3 shadow-none"
                      onClick={() =>
                        navigate(`/event/${event_ids.join(',')}`, {
                          state: event_title,
                        })
                      }
                    >
                      Athlete
                    </button>
                  ),
                },
              ]}
              totalRecords={recordsData}
              recordsPerPage={pageSize}
              // page={page}
              onPageChange={(p) => setPage(p - 1)}
              recordsPerPageOptions={PAGE_SIZES}
              onRecordsPerPageChange={setPageSize}
              sortStatus={sortStatus}
              onSortStatusChange={setSortStatus}
              minHeight={200}
              loading={loading}
              fetching={loading}
              paginationText={({ from, to, totalRecords }) =>
                `Showing  ${from} to ${to} of ${totalRecords} entries`
              }
            />
            {rowData?.length !== 0 && (
              <CustomPagination
                total={recordsData}
                page={page}
                handleChange={handleChange}
                dataPerPage={pageSize}
                handleDataPerPage={handleDataPerPage}
                PAGE_SIZES={PAGE_SIZES}
              />
            )}
          </>
          {/* )} */}
        </div>
      </div>
    </div>
    // </DefaultLayout>
  );
};

export default Basic;
